import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Row } from "react-bootstrap";

const NetworkProfileActionCell = props => (
  <Row style={{ display: "block" }}>
    <div className="floatRight">
      <Button
        size="sm"
        className="btn-red"
        onClick={event => {
          event.stopPropagation();
          props.onDelete();
        }}>
        <FontAwesomeIcon icon={faTrash} size="1x" />
      </Button>
    </div>
  </Row>
);

export default NetworkProfileActionCell;
